export default __webpack_public_path__ + "static/media/ClinicAppointment.98d1f032.svg";